import * as React from 'react';
import Select from 'react-select';
import { useAppDispatch } from '../../../hooks/useAppDispatch';
import { useAppSelector } from '../../../hooks/useAppSelector';
import { selectTheme, styles } from '../../../services/selectTheme';
import { WeatherSearchKey, SelectProperties } from '../../../store/weatherSearchDefaults';
import { valueChanged } from '../../../store/weatherSearchSlice';
import { FormLabel } from './label';
import IcoSearch from 'images/search.svg';



export interface FormSelectProps {

    prop: WeatherSearchKey,
    label: string,
    onChange?: (val: string | number) => void
}


export const FormSelect = ({ prop, label, onChange }: FormSelectProps) => {
    const val = useAppSelector(state => {
        return (state.weatherSearch.searchProperties[prop] as SelectProperties<number | string>).val;
    });
    const options = useAppSelector(state => {
        return (state.weatherSearch.searchProperties[prop] as SelectProperties<number | string>).options;
    });
    const dispatch = useAppDispatch();
    const value = options.find(o => o.value === val);

    const onChangeInternal = (option: { label: string, value: string | number }) => {
        if (onChange) {
            onChange(option.value);
        }
        dispatch(valueChanged({ prop, val: option.value }));
    }

    return (<>
        <FormLabel label={label} icon={IcoSearch} />
        <Select
            styles={styles}
            options={options}
            value={value}
            theme={selectTheme}
            isSearchable={false}
            onMenuOpen={() => { }}
            onChange={onChangeInternal}
            placeholder=""
        />
    </>
    )
}

